import React, { useState } from 'react';
import { Search } from 'lucide-react';
import '../styles/Navbar.css';

const Navbar = ({ searchQuery, setSearchQuery }) => {
    // Local state to track input value without triggering API calls
    const [localSearchQuery, setLocalSearchQuery] = useState(searchQuery);

    // Handle key press events (Enter or Space)
    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            // Only trigger API call if there's a change
            if (localSearchQuery !== searchQuery) {
                setSearchQuery(localSearchQuery);
            }
        } else if (e.key === ' ') {
            // Don't preventDefault for space - let it be typed
            // Trigger search after a brief delay to allow the space to be added
            setTimeout(() => {
                setSearchQuery(localSearchQuery + ' ');
            }, 0);
        }
    };

    // Handle search icon click
    const handleSearchClick = () => {
        // Only trigger API call if there's a change
        if (localSearchQuery !== searchQuery) {
            setSearchQuery(localSearchQuery);
        }
    };

    return (
        <div className="navbar-news">
            <div className="navbar-content-news">
                <div className="navbar-left-news">
                    <div className="logo-icon-news"></div>
                    <h1 className="logo-text-news">COMPETITOR NEWS</h1>
                </div>
                <div className="search-container-navbar-news">
                    <div className="search-wrapper-news">
                        <input
                            type="text"
                            placeholder="What are you looking for?"
                            value={localSearchQuery}
                            onChange={(e) => setLocalSearchQuery(e.target.value)}
                            onKeyDown={handleKeyDown}
                            className="search-input-news"
                        />
                        <Search
                            className="search-icon-news"
                            size={20}
                            onClick={handleSearchClick}
                            style={{ cursor: 'pointer' }}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Navbar;
